import React, { Component } from "react";
import { regionForDomain } from "../../Shared/locations";

class HomeVenues extends Component {
  render() {
    return (
      <div>
        {/* Venues VIC */}
        {regionForDomain() === "VIC" && (
          <section className="venues">
            <div className="container">
              <h2>Venues</h2>
              <div className="col-sm-6">
                <div className="location">
                  <h3>Bentleigh</h3>
                  <h4>Temple Society</h4>
                  <h4>152 Tucker Road</h4>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="location">
                  <h3>Flemington</h3>
                  <h4>Flemington Community Centre</h4>
                  <h4>25 Mt Alexander Rd</h4>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="location">
                  <h3>Bulleen</h3>
                  <h4>The Manningham</h4>
                  <h4>1 Thompsons Road</h4>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="location">
                  <h3>Bayswater</h3>
                  <h4>Temple Society Community Centre Reserve</h4>
                  <h4>51 Elizabeth St</h4>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Venues SA */}
        {regionForDomain() === "SA" && (
          <section className="venues">
            <div className="container">
              <h2>Venues</h2>

              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Torrensville </h3>
                    <h4>Thebarton Community Centre</h4>
                    <h4>South Rd & Ashwin Parade</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Glenelg</h3>
                    <h4>The Pier Hotel</h4>
                    <h4>18 Holdfast Prom </h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Park Holme</h3>
                    <h4>Park Holme Community Hall</h4>
                    <h4>638 Marion Road</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Aberfoyle Park</h3>
                    <h4>Aberfoyle Community Centre </h4>
                    <h4>Cnr of Jessica Street and Sandpiper Crescent</h4>
                    <h4>1 Jessica St</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Fullarton</h3>
                    <h4>Fullarton Park Community Centre</h4>
                    <h4>411 Fullarton Rd</h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Venues NSW */}
        {regionForDomain() === "NSW" && (
          <section className="venues">
            <div className="container">
              <h2>Venues</h2>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>North Parramatta</h3>
                    <h4>Uniting Venues</h4>
                    <h4>16 Masons Drive</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Chatswood</h3>
                    <h4>Dougherty Community Centre</h4>
                    <h4>7 Victor Street</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Bondi</h3>
                    <h4>Margaret Whitlam Recreation Centre</h4>
                    <h4>Bondi Junction</h4>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Newcastle</h3>
                    <h4>Charlestown Community Centre</h4>
                    <h4>Frederick St</h4>
                    <h4>Charlestown</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Central Coast</h3>
                    <h4>Tuggerah Lakes Community Centre</h4>
                    <h4>1 Bay Village Road</h4>
                    <h4>Bateau Bay</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Wollongong</h3>
                    <h4>Berkeley Community Centre</h4>
                    <h4>40 Winnima Way</h4>
                    <h4>Berkeley</h4>
                  </div>
                </div>
              </div>
              <div className="row"></div>
            </div>
          </section>
        )}

        {/* Venues WA */}
        {regionForDomain() === "WA" && (
          <section className="venues">
            <div className="container">
              <h2>Venues</h2>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Osborne Park</h3>
                    <h4>Osborne Community Centre</h4>
                    <h4>11 Royal St</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Kwinana </h3>
                    <h4>Darius Wells </h4>
                    <h4>Chisham Ave and Robbos Way</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Gosnells</h3>
                    <h4>The Agonis</h4>
                    <h4>2232 Albany Highway</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>South Perth</h3>
                    <h4>John McGrath Pavilion</h4>
                    <h4>97 Hensman Street </h4>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3> Mandurah Seniors & Community Centre</h3>
                    <h4>41 Ormsby Terrace</h4>
                    <h4>Mandurah</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Maylands</h3>
                    <h4>The Rise</h4>
                    <h4>28 Eighth Ave, Maylands</h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Venues QLD */}
        {regionForDomain() === "QLD" && (
          <section className="venues">
            <div className="container">
              <h2>Venues</h2>

              <div className="row">
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Nerang </h3>
                    <h4>Nerang Bicentennial Community Centre</h4>
                    <h4>833 Southport Nerang Rd, Nerang</h4>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="location">
                    <h3>Toombul </h3>
                    <h4>Toombul Shire Hall</h4>
                    <h4>1141 Sandgate Road, Toombul</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Inala </h3>
                    <h4>Inala Hall (Old Hall)</h4>
                    <h4>Rosemary St & Abelia St </h4>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="location">
                    <h3>Moorooka </h3>
                    <h4>Moorooka Community Centre </h4>
                    <h4>40 Gainsborough Street, Moorooka</h4>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="location">
                    <h3>Bokarina (Sunshine Coast) </h3>
                    <h4>Venue 114</h4>
                    <h4>114 Sportsmans Parade, 4575</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Helensvale</h3>
                    <h4>Helensvale Community Centre</h4>
                    <h4>31 Discovery Drive</h4>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="location">
                    <h3>Helensvale</h3>
                    <h4>Helensvale Library and Cultural Centre</h4>
                    <h4>62 Sir John Overall Dr</h4>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="location">
                    <h3>Inala</h3>
                    <h4>Inala Hall (New Hall)</h4>
                    <h4>Corner Corsair Avenue and Wirraway Parade</h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
export default HomeVenues;
